<template>
    <div>
        <v-card>
            <v-row class="ml-1 mr-1">
                <v-col cols="11">
                    <v-card-title class="titulopagina"> DESPACHOS DE ACEITE ROMANA Y RECEPCION EN BODEGAS</v-card-title>
                </v-col>
                <v-col cols="1">
                    <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                </v-col>
            </v-row>                
		    <modal-ayuda></modal-ayuda>
        </v-card>

         <!-- tabla despachos -->
        <v-card class="mt-2">
            <v-row class="ml-1 mr-1">
                <v-col cols="7">
                    <v-card-title>
                        DESPACHOS ACEITE ROMANA Y RECEPCION EN BODEGAS
                    </v-card-title>
                </v-col>
                <v-col cols="2">
                    <date-picker class="float-right" v-model="fecha" range-separator="|" range placeholder="Fecha Despachos"  @change="cargarDespachos" format="DD-MM-YYYY" valueType="YYYY-MM-DD"></date-picker>
                </v-col>
                <v-col cols="3">
                    <table width="100%" v-if="despachos_sin_detalle.length > 0">
                        <thead>
                            <tr><th colspan="4">Despachos Romana sin Detalle</th></tr>
                            <tr>
                                <th>Ticket</th>
                                <th>Fecha Desp.</th>
                                <th>Guía</th>
                                <th>Peso</th>
                            </tr>
                        </thead>
                        <tr v-for="item in despachos_sin_detalle" :key="item.id">
                            <td>{{item.codigo_ticket}}</td>
                            <td>{{item.fecha_hora_ticket | fechaCompleta}}</td>
                            <td>{{item.numero_guia}}</td>
                            <td>{{item.peso_sernapesca}}</td>
                        </tr>
                    </table>
                </v-col>
            </v-row>
           

            <v-data-table 
                :headers="cabeceras_romana"
                :items="lista_romana"
                :items-per-page="20"
                class="elevation-2 mt-1"
                dense
            >
                <template v-slot:item.url_guia="prop">
                    {{ prop.item.numero_guia }}
                    <v-btn class="ma-2" color="indigo" dark icon @click="goto(prop.item.url_guia)">
                        <v-icon dark>description</v-icon>
                    </v-btn>
                    <!-- <v-btn href="#" @click="goto(prop.item.url_guia)" dense color="#82B1FF">Ver guía</v-btn> -->
                </template>

                <template v-slot:item.class="prop">
                    <v-btn class="ma-2" dense @click="showModal(prop.item)" :color="prop.item.color" title="Asignar Despacho - Indicar Producción Origen" >
                        <v-icon dark>assignment</v-icon>
                    </v-btn>
                    <v-btn class="ma-2" v-if="(prop.item.pendiente == 0) && prop.item.bodega_destino" dense @click="modalRecepcion(prop.item)" :color="prop.item.color2" title="Recepción Aceite Bodegas Externas" >
                        <v-icon dark>assignment_turned_in</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>

        <!-- tabla despachos -->

        <v-dialog
            v-model="dialog"
            max-width="1100px"
            activator=""
            @click:outside="closeDialog"
            persistent
        >
            <v-card elevation="15">
                <v-card-text>
                    <v-row>
                        <v-col cols="7">
                            <v-card-title>
                                <v-card-title class="titulopagina"> Distribuir Despacho </v-card-title>
                            </v-card-title>
                        </v-col>
                        
                        <v-col cols="3">
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="dialog=false" >
                                    Cerrar
                                </v-btn>
                            </v-card-actions>
                        </v-col>
                        <v-col cols="2">
                            <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyuda2"><v-icon color="blue" large>help</v-icon></v-alert>
                        </v-col>
                        <modal-ayuda2></modal-ayuda2>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card elevation="15">
                <v-card-text>
                    <v-row>
                        <v-progress-linear 
                            v-if="progreso_despacho"
                            indeterminate
                            color="#0D47A1"
                        ></v-progress-linear>
                    </v-row>

                    <v-row>
                        <v-col cols="4">
                            <h3 class="cyan lighten-3 mt-2">INFORMACIÓN DE LABORATORIO :</h3>
                        </v-col>
                        <v-col cols="8">
                            <h4 class="cyan lighten-5 mt-2">Fecha Romana : {{despacho_romana.fecha_hora_ticket | fechaCompleta}} 
                                ... {{despacho_romana.patente}} ->  {{despacho_romana.sucursal}}</h4>
                        </v-col>
                    </v-row>
                    <v-row v-for="it in despacho" :key="it.id">
                        <v-col cols="2">
                            <v-text-field v-model="despacho_romana.numero_guia" label="Guia de despacho" readonly></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-text-field v-model="despacho_romana.peso_real" label="Peso" readonly></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-model="litros_restantes_despacho" label="Por Asignar" readonly></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-select
                                v-model="estanque_seleccionado"
                                :items="estanques"
                                class="pt-3"
                                label="Estanque"
                                item-text="nombre"
                                item-value="id"
                                color="blue darken-3"
                                persistent-hint
                                dense
                            >
                            </v-select>
                        </v-col>
                        <v-col cols="1">
                            <v-text-field v-model="it.acidez" label="Acidez" readonly></v-text-field>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field @input="guardarSello()" v-model="it.sello" label="Sello"></v-text-field>
                        </v-col>
                        <v-col cols="1">
                            <v-btn class="ma-2" color="indigo" dark icon @click="goto(despacho_romana.url_guia)">
                                Guía {{ despacho_romana.numero_guia }} <v-icon dark> description </v-icon>  
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row v-if="!despacho.length" >
                        <v-alert dense text type="warning">
                            No hay Despachos de Aceite registrados en laboratorio para esta fecha / guía (Menú ACEITE -> Despacho de Aceite Laboratorio)  
                            <v-btn icon class="float-right" color="red darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                        </v-alert>
                        <v-col cols="2">
                            <v-select
                                v-model="estanque_seleccionado"
                                :items="estanques"
                                class="pt-3"
                                label="Estanque"
                                item-text="nombre"
                                item-value="id"
                                color="blue darken-3"
                                persistent-hint
                                dense
                            >
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card elevation="15">
                <v-card-text>
                    <v-row v-if="alerta_graba" >
                        <v-alert dense text type="warning">
                            No se puede distribuir más que el peso de la guía ( {{ despacho_romana.peso_real }} )  ni más que la producción o disponible de cada fila
                        </v-alert>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <h1 :class="{alert: litros_restantes_despacho > 0}">Por Asignar: {{litros_restantes_despacho}} (Lts)</h1>
                        </v-col>

                        <v-col cols="3">
                            <v-row>
                                <h3 class="green lighten-4">Distribuido:</h3>
                            </v-row>
                            <v-row v-for="d in distribuideishons" :key="d.id">
                                <v-col class="pa-0" cols="3"> {{ d.estanque }}</v-col>
                                <v-col class="pa-0" cols="9"> {{ d.propuesta }} </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="3">
                            <v-row>
                                <v-select
                                    :items="bodegas"
                                    item-text="nombre"
                                    item-value="id"
                                    v-model="bodega_destino"
                                    label="Seleccione Bodega Destino"
                                    dense
                                ></v-select> 
                            </v-row>
                            <v-row>
                                <v-text-field v-model="folio_destino" label="Folio Destino"></v-text-field>
                            </v-row>
                        </v-col>
                        <v-col cols="2">
                            <h3 title="Botón Grabar se habilita cuando " class="green lighten-4">Grabar</h3>
                            <v-btn color="green accent-4" v-if="litros_restantes_despacho == 0 && es_calidad" @click="grabar_propuesta()"><v-icon>done</v-icon> Grabar </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <v-card elevation="15">
                <v-card-text>
                    <v-row>
                        <span class="pl-5 pr-5"><b>Lectura de colores : </b></span>
                        <span class="pl-5 pr-5">Disponible</span>
                        <!-- <span class="propuesta-1 pl-5 pr-5">Despacho total</span>
                        <span class="propuesta-2 pl-5 pr-5">Despacho parcial</span>-->
                        <span class="propuesta-3 pl-5 pr-5">Distribuir</span>
                        <span class="propuesta-5 pl-5 pr-5">Supera máximo</span>
                    </v-row>
                    <v-row>
                        <table width="100%">
                            <thead>
                                <tr>
                                    <th class="cabecera borde-left">Fecha</th>
                                    <th class="cabecera borde-left">Estanque</th>
                                    <th class="cabecera borde-left">Producción</th>
                                    <th class="cabecera borde-left">Despachado</th>
                                    <th class="cabecera borde-left">Disponible</th>
                                    <th class="cabecera borde-left">Distribuir</th>
                                    <th class="cabecera borde-left">Despacho</th>
                                    <th class="cabecera borde-left">Fecha Desp.</th>
                                    <th class="cabecera borde-left">Ticket/Guía</th>
                                </tr>
                            </thead>

                            <tr v-for="item in estanques_producciones" :key="item.id">
                                <template v-if="item.estanque_aceites_id == estanque_seleccionado">
                                    <td><p v-if="item.mostrar==1">{{item.fecha}}</p></td>
                                    <td><p v-if="item.mostrar==1">{{item.estanque}}</p></td>
                                    <td><p v-if="item.mostrar==1">{{item.produccion}}</p></td>
                                    <td><p v-if="item.mostrar==1">{{item.despachos}}</p></td>
                                    <td><p v-if="item.mostrar==1">{{ parseInt(item.produccion || 0) - parseInt(item.despachos || 0) }}</p></td>

                                    <td :class="`${item.color != 1 ? `propuesta-${item.color}` :''}`"> 
                                        <v-text-field hide-details="auto" class="pt-0 text-right" :value="item.propuesta" @change="validaPropuesta(item,$event)"> </v-text-field>
                                    </td>
                                    <td :class="`${item.color == 1 ? `propuesta-${item.color}` :''}`">{{item.despachado}}</td>
                                    <td>{{item.fecha_d}}</td>
                                    <td>{{item.guia}}</td>

                                </template>     <!-- 0 = disponible | 1 = tiene despacho total | 2 = tiene despacho parcial | 3 = se propone despacho | 5 = se pasa del valor máximo  -->
                            </tr>
                        </table>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-divider></v-divider>
                
        </v-dialog>

         <modal-recepcion></modal-recepcion>
    </div>
</template>
<script>
import {mapState, mapMutations} from 'vuex';
//import Tabla from '@/components/shared/Tabla.vue'
import Data_Table from '@/components/shared/Data_Table.vue';
import Modal from '@/components/shared/Modal.vue';
import Loader_Lineal_Configurable from '@/components/shared/Loader_Lineal_Configurable.vue';
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import Modal_RecepcionAceite from '../../components/shared/Modal_RecepcionAceite.vue';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
// import axios from 'axios'
export default {
    data:()=>({
        es_calidad: false,
        despacho: {},
        despachos: [],
        bodegas: [],
        bodega_destino:'',
        folio_destino:'',
        lista_romana: [],
        lista_estanques: [],
        estanques:[],
        estanques_despacho:[],
        estanques_producciones:[],
        estanques_producciones_resp:[],
        despachos_sin_detalle:[],
        por_asignar:0,
        estanque_seleccionado:0,
        turnos: [],
        fecha: new Date().toISOString().substr(0, 10),
        dialog: false,
        dialogRecepcion: false,
        alert:false,
        alerta_graba:false,
        despacho_romana: [],
        progreso_despacho:false,
        //configuracion para datatable
        cabeceras_romana:[
            {
                text: 'Fecha Salida',
                align: 'center',
                sortable: true,
                value: 'fecha_hora_ticket',
                class: 'cabecera',
            },
            {
                text: 'Patente',
                align: 'center',
                sortable: true,
                value: 'patente',
                class: 'cabecera',
            },
            {
                text: 'Producto',
                align: 'center',
                sortable: true,
                value: 'producto',
                class: 'cabecera',
            },
            {
                text: 'Destino',
                align: 'center',
                sortable: true,
                value: 'sucursal',
                class: 'cabecera',
            },
            {
                text: 'Ticket',
                align: 'center',
                sortable: true,
                value: 'codigo_ticket',
                class: 'cabecera',
            },
            {
                text: 'Guia',
                align: 'center',
                sortable: true,
                value: 'url_guia',
                class: 'cabecera',
            },
            {
                text: 'Cantidad',
                align: 'center',
                sortable: true,
                value: 'peso_real',
                class: 'cabecera',
            },
            {
                text: 'Por Asignar',
                align: 'center',
                sortable: true,
                value: 'pendiente',
                class: 'cabecera',
            },
            {
                text: 'Total Asignado',
                align: 'center',
                sortable: true,
                value: 'distribuido',
                class: 'cabecera',
            },
            {
                // text: 'Estanque',
                text: 'Asignar',
                align: 'center',
                sortable: true,
                value: 'class',
                class: 'cabecera',
            }
        ],
    }),
    mounted() {
        this.cargarTurnos();
        this.cargarEstanques();
        this.cargarBodegas();
        Event.$on('actualizar_tabla',()=>{
            this.cargarDespachosRomana();
        });
    },
    methods: {
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Despachos de Aceite y Recepciones en Bodegas`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se muestran los despachos de aceite que han pasado por la romana de la Planta.`},
                        {   tipo:`label`,   texto:`- Las columnas de la tabla son: Fecha de Salida = fecha peso bruto del ticket, Patente del camión que transporta, Producto = Aceite, Destino de la carga, Número del ticket, Número e imagen de la guía, Cantidad = peso según romana, Por Asignar = Cantidad del despacho que está pendiente de indicar su origen, Total Asignado = Cantidad del despacho que se le ha asignado origen. `},
                        {   tipo:`imgtexto`,  url:`despacho-recepcion-aceite.png`, ratio:'5', cols:'2', texto:`Botones al final de cada fila: el primer botón es para asignar información del origen de producción del producto despachado, el segundo botón es para indicar información de la recepción en la bodega externa. Si no aparece el segundo botón es porque no se ha registrado la información del origen o la bodega de destino.`},
                    ]
            Event.$emit('mostrar_alert',jiji);
        },
        abrirAyuda2(){
            let jiji = [
                        {   titulo:`Ayuda de " Distribuir Despachos "`,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`- En esta pantalla de registra el origen de producción de un despacho de aceite.`},
                        {   tipo:`label`,   texto:`- En el primer bloque se muestra la información de Laboratorio registrada previa a la salida del camión en Romana: Guía de despacho, estanque de origen, acidez del aceite según muestreo de camión y número de sello.`},
                        {   tipo:`label`,   texto:`- Si no está la información de laboratorio, se puede registrar en el menú de "Despacho de Aceite Lab". `},
                        {   tipo:`label`,   texto:`- En el siguiente bloque se va calculando automáticamente la diferencia entre el peso de romana de la guía y lo que se ha distribuído. Cuando se ha distribuído el 100% se habilita la opción de Grabar. Al grabar se habilitará la opción de recepción en bodegas externas de ese despacho.`},
                        {   tipo:`label`,   texto:`- En la tabla inferior, columna "Distribuir", se va indicando el origen de producción del despacho (registro de cantidad que se está despachando de cada producción). El sistema valida que no se despache más de lo registrado en una fecha de producción o de lo que quede disponible`},
                    ]
            Event.$emit('mostrar_alert',jiji);
        },
        closeDialog(){
            if(this.litros_restantes_despacho > 0){
                console.log('Falta distribuir')
                this.dialog = true;
                return
            }
            this.dialog = false;
        },
        async cargarTurnos(){
            let url = `${this.base_url}turnos`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.turnos = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarEstanques(){
            let url = `${this.base_url}estanque_aceites`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                this.estanques = res.data.data;
                this.estanques_despacho = res.data.data;
                await this.limpiarEstanquesDespacho(this.estanques_despacho);
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async limpiarEstanquesDespacho(estanques){
            await estanques.forEach(e => {
                this.$set(e,'despacho_pt_id',0);
                this.$set(e,'kilos',0);
                this.$set(e,'acidez_aceite', this.despacho != undefined ? this.despacho.acidez : 0);
                this.$set(e,'bins',0);
                this.$set(e,'sellos',0);
            });
        },
        async cargarDespachos(){
            this.cargarDespachoAceite();
            this.cargarDespachosRomana();
            this.cargarDespachosAceite();
            this.cargarDespachosSinDetalle();
        },
        async cargarBodegas(){
            this.mostrarLoading({titulo:'Cargando bodegas...',color:'green'})
            let url = `${this.base_url}bodegas?tipo_produccion_id=2`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.bodegas = res.data.data;
                this.ocultarLoading();
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar bodegas ");
            });
        },
        async cargarDespachoAceite(){  // despacho de aceite de laboratorio
            let fecha_ini = this.fecha[0];
            let fecha_fin = this.fecha[1];

            let manana = this.moment(fecha_fin).add(1, 'days').format('YYYY-MM-DD');
            let ayer = this.moment(fecha_ini).subtract(1, 'days').format('YYYY-MM-DD');
            let url = `${this.base_url}despacho_aceite/por_fecha/${ayer}/${manana}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.despachos = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarDespachosRomana(){
            this.mostrarLoading({titulo:'Cargando Datos...',color:'green'})
            this.alert = false;
            let fecha_ini = this.fecha[0];
            let fecha_fin = this.fecha[1];
            let url = `${this.base_url}produccion_aceite/despachos_romana/${fecha_ini}/${fecha_fin}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.lista_romana = response.data.data;
                this.ocultarLoading();
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarDespachosAceite(){
            let fecha_ini = this.fecha[0];
            let fecha_fin = this.fecha[1];
            let url = `${this.base_url}produccion_aceite/despachos/${fecha_ini}/${fecha_fin}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.lista_estanques = response.data.data;

            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        async cargarDespachosSinDetalle(){
            let fecha_ini = this.fecha[0];
            let fecha_fin = this.fecha[1];
            let url = `${this.base_url}produccion_aceite/despachos_sin_detalle/${fecha_ini}/${fecha_fin}`;
            await this.axios.get(url, this.headers).then((response)=>{
                this.despachos_sin_detalle = response.data.data;
            }).catch((error)=>{
                console.log(error);
                this.ocultarLoading();
            });
        },
        guardarSello(){
            this.lista_estanques.forEach(estanque => {
                this.$set(estanque, 'sellos', this.despacho != undefined ? this.despacho.sello : 0);
            });
        },
        goto(link){
            let url_actual = window.location.href
            if(url_actual.includes('190.13.184.67') || url_actual.includes('localhost')){
                window.open("https://190.13.184.67:444/romana2/backend/public/guias/"+link);
            }else if(url_actual.includes('192.168.205.150')){
                window.open("https://192.168.205.150/romana2/backend/public/guias/"+link);
            }
        },
        async grabar_propuesta(){
            this.progreso_despacho = true;
            let toSave = []
            let data = {}
            console.log("despacho_romana", this.despacho_romana)
            console.log("despacho", this.despacho)
            this.estanques_producciones.forEach( row => {
                if (row.propuesta > 0) {
                    data = { "pt_id":row.pt_id, "propuesta":row.propuesta, "estanque":row.estanque_aceites_id};
                    toSave.push( data );
                }
            });
            let acidez = this.despacho[0] ? this.despacho[0].acidez : ''
            let sello = this.despacho[0] ? this.despacho[0].sello : ''

            data = {    "guia_nro": this.despacho_romana.numero_guia,
                        "guia_id": this.despacho_romana.guias_id,
                        "ticket": this.despacho_romana.codigo_ticket, 
                        "desp_romana": this.despacho_romana.id,
                        "bodega_destino": this.bodega_destino,
                        "folio_destino": this.folio_destino,
                        "acidez": acidez, "sello": sello,
                        "asignado": toSave}
            console.log(data);
            let url = `${this.base_url}despachos_pts/asignar_despacho`;
            await this.axios.post(url, data, this.headers).then((response) => {
                let resp = response.data.data;
                this.cargarDespachosRomana();
                this.dialog = false
                console.log("resp", resp)
            }).catch((error)=>{
                console.log(error);
                this.errorMessage(error, "Error al Guardar Distribución ");
            });
            this.progreso_despacho = false;

        },
        async showModal(item){
            this.despacho_romana = item;
            this.despacho = this.despachos.filter(d => {
                return (d.guia == item.numero_guia);
            })
            if((this.despacho == undefined) || (!this.despacho[0]) ) {
                this.despacho = {}
                this.estanque_seleccionado = 0
                this.bodega_destino = ''
                this.folio_destino = ''
            } else {
                this.estanque_seleccionado = this.despacho[0].estanque_aceites_id
                this.bodega_destino = this.despacho_romana.bodega_destino
                this.folio_destino = this.despacho_romana.folio_destino
            }
            console.log("showModal",this.despacho)
            await this.cargarDistribucionEstanques(this.despacho_romana.tickets_id,this.despacho_romana.numero_guia);
            this.dialog = true;
            this.alerta_graba = false
        },
        modalRecepcion($item){
            this.$emit('abrir_modal_recepcion',$item);
            //Event.$emit('abrir_modal_jumbo',null,configuracion);
        },
       /* async modalRecepcion(item){
            this.despacho_romana = item;
            console.log(item)
            // await this.cargarDistribucionEstanques(this.despacho_romana.tickets_id,this.despacho_romana.numero_guia);
            this.dialogRecepcion = true;
        },*/

        async cargarDistribucionEstanques(ticket,guia){
            let url = `${this.base_url}despacho_pts/despacho_id/${ticket}/${guia}`;
            await this.axios.get(url,this.headers).then(async (res)=>{
                this.estanques_producciones = res.data.producciones;
                this.es_calidad = res.data.es_calidad;
                //this.estanques_producciones_resp = res.data.producciones;
            }).catch((error)=>{
                console.log('error',error);
            });
            this.calcula_propuesta();
        },
        checkDistribucion(){
            if(litros_restantes_despacho != 0){
                console.log('No se ha distribuido correctamente');
            }
        },
        validaPropuesta(item, event) {

            //event.preventDefault()
            let validar_valor = parseInt(this.por_asignar || 0) + parseInt(item.propuesta || 0) - parseInt(event|| 0)
            let validar_valor2 = parseInt(item.produccion || 0) - parseInt(item.despachos || 0) + parseInt(item.propuesta || 0)  - parseInt(event|| 0)
        console.log('validar_valor', validar_valor, 'validar_valor2',validar_valor2,'pa',this.por_asignar,'pp',item.propuesta,'e',event,'prod',item.produccion,'desp',item.despachos);

            let idx = this.estanques_producciones.findIndex(r => r.id == item.id)
            let lts = Math.min( validar_valor, validar_valor2 )

            if (lts >= 0) {
                // AQUI SE MANTIENE EL VALOR QUE EL USUARIO DIGITÓ EN INPUT
                this.alerta_graba = false
                //item.propuesta = event
                this.$set(this.estanques_producciones[idx], 'propuesta', event);
                this.$set(this.estanques_producciones[idx], "color", 3)
            } else {
                // AQUI SE DEBE VOLVER AL VALOR QUE EL INPUT TENIA ANTES DEL CHANGE
                this.alerta_graba = true
                let valor = parseInt(event || 0) + parseInt(lts || 0);
                event = valor > 0 ? valor : 0;

                this.$set(this.estanques_producciones[idx], 'propuesta', event);
                this.$set(this.estanques_producciones[idx], 'color', 5)
            }
        },

        calcula_propuesta(){
            let cant = 0
            let lts = 0
            let pt_id = 0
            this.estanques_producciones.forEach(e =>{
                lts += parseInt(e.propuesta || 0) 
            })
            lts = parseInt(this.despacho_romana.peso_real || 0)  - lts

            let tk_prod = this.estanques_producciones.filter( f => {
                 return (f.estanque_aceites_id == this.estanque_seleccionado); 
            })
            if (lts > 0){
                tk_prod.map( (row) => {
                    if ((lts > 0) && (pt_id != row.pt_id)){
                        console.log("despacho_romana",this.despacho_romana, "row", row)

                        cant =  parseInt(row.produccion || 0) - parseInt(row.despachos || 0)
                        if (cant > 0){
                            row.propuesta = Math.min(cant, lts)
                            lts -= row.propuesta
                        }
                        pt_id = row.pt_id
                    }
                })
            }
            console.log('tk_prod', tk_prod)
            //return tk_prod
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
        ...mapState(['base_url', 'headers', 'roles']),
        fecha_formateada () {
          return this.fecha ? this.moment(this.fecha).format('DD-MM-YYYY') : '';
        },
        litros_restantes_despacho(){
            let litros = 0;
            if(this.despacho_romana){
                litros = this.despacho_romana.peso_real;
                this.estanques_producciones.forEach(e => {
                    litros -= parseInt(e.propuesta || 0);
                });
            }
            this.por_asignar = litros
            return litros;
        },

        distribuideishons(){
            let tk_prod = this.estanques_producciones.filter( f => {
                //console.log(f)
                return (f.propuesta > 0); 
            })
            return tk_prod
        },

    },
    components:{
        'modal':Modal,
        'modal-recepcion':Modal_RecepcionAceite,
        'data-table':Data_Table,
        'loader-configurable':Loader_Lineal_Configurable,
        DatePicker,
        'modal-ayuda':ModalAyudas,
        'modal-ayuda2':ModalAyudas,
    }
}
</script>
<style scoped>
    .mx-datepicker{
        width: 100% !important;
    }
    .alert{
        color: red;
    }
    /** 0 = disponible | 1 = tiene despacho total | 2 = tiene despacho parcial | 3 = se propone despacho | 5 = se pasa del valor máximo  */
    .propuesta-1{background-color: #00A2FA;}
    .propuesta-2{background-color: #00E1FA;}
    .propuesta-3{background-color: #69E312;}
    .propuesta-5{background-color: #FDDE14;}


</style>